// extracted by mini-css-extract-plugin
export default {"btnsContainer":"form_btnsContainer__VFlyH"};